import React from 'react'
import * as Constants from './../../../../helpers/constants'
import CurrencyDropdown from './../dropdowns/currency_dropdown'
import ProdcutIntervalDropdowns from '../dropdowns/interval_dropdowns'
import CreditsIntervalDropdowns from '../dropdowns/credit_interval_dropdowns'
import ProductAmountInput from '../inputs/amount_input'
import ProductIsCustomCheckbox from '../checks/is_custom_checkbox'
import ProductIsRecurringCheckbox from '../checks/recurring_checkbox'
import ResetCreditsCustomCheckbox from '../checks/reset_credit_checkbox'

const CreatePlanProduct = ({ onStateChange, client, family, units = {}, ...props }) => {

  return (
    <div className="plan-product-form">

      {client === Constants.CLIENTS.CLEAROUTPHONE.NAME && (
        <>
          <div className="form-group">
            <label htmlFor="family">Family</label>
            <select
              id="family"
              className="form-control"
              value={family || 'cop_one'}
              onChange={(e) => onStateChange('family', e.target.value)}
            >
              <option value="cop_one">COP One</option>
              <option value="pnv">Phone Number Validation</option>
              <option value="pnq">Phone Number Qualification</option>
            </select>
          </div>
          <div className="form-group">
            <label>Units</label>
            <div className="row">
              {(family === 'cop_one' || family === 'pnv') && (
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="phone-number-validation">
                      Phone Number Validation Units
                    </label>
                    <input
                      id="phone-number-validation"
                      type="number"
                      className="form-control"
                      min="0"
                      value={units.phone_number_validation ?? 5000}
                      onChange={(e) =>
                        onStateChange('units', {
                          ...units,
                          phone_number_validation: Number(e.target.value),
                        })
                      }
                    />
                  </div>
                </div>
              )}
              {/* Right side: Phone Number Qualification Units */}
              {(family === 'cop_one' || family === 'pnq') && (
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="phone-number-qualification">
                      Phone Number Qualification Units
                    </label>
                    <input
                      id="phone-number-qualification"
                      type="number"
                      className="form-control"
                      min="0"
                      value={units.phone_number_qualification ?? 5000}
                      onChange={(e) =>
                        onStateChange('units', {
                          ...units,
                          phone_number_qualification: Number(e.target.value),
                        })
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
      <CurrencyDropdown onStateChange={onStateChange} />
      <ProdcutIntervalDropdowns onStateChange={onStateChange} />
      <CreditsIntervalDropdowns onStateChange={onStateChange} />
      <div className="plan-amount-n-credits">
        <ProductAmountInput
          onStateChange={onStateChange}
          {...props}
        />
      </div>
      <div className="plan-custom-n-recurring">
        <ProductIsCustomCheckbox onStateChange={onStateChange} />
        <ProductIsRecurringCheckbox
          disabled={true}
          onStateChange={onStateChange}
        />
        <ResetCreditsCustomCheckbox onStateChange={onStateChange} />
      </div>
    </div>
  )
}

export default CreatePlanProduct